export enum ECadFormat {
  STEP = 'step',
  STP = 'stp',
  IGES = 'iges',
  IGS = 'igs',
  X_T = 'x_t',
}

export const BASE_API_URL = '/api/frontend/v1';

export const GET = 'GET_';
export const POST = 'POST_';
export const DELETE = 'DELETE_';
export const UPDATE = 'UPDATE_';
export const SET = 'SET_';
export const CREATE = 'CREATE_';
export const MOVE = 'MOVE_';
export const TRIGGER = 'TRIGGER_';
export const DOWNLOAD = 'DOWNLOAD_';
export const SEARCH = 'SEARCH_';
export const ADD = 'ADD_';
export const START = 'START_';
export const CLEAR = 'CLEAR_';
export const PAUSE = 'PAUSE_';
export const SHOW = 'SHOW_';
export const MARK = 'MARK_';
export const CLICK = 'CLICK_';
export const RECOVER = 'RECOVER_';
export const ROLLBACK = 'ROLLBACK';
export const UNDO = 'UNDO_';
export const REDO = 'REDO_';
export const ADJUST = 'ADJUST_';
export const EXPORT = 'EXPORT_';
export const PATCH = 'PATCH_';
export const GROUP = 'GROUP_';
export const GROUPS = 'GROUPS_';
export const IMPORT = 'IMPORT_';
export const COLLAPSED = 'COLLAPSED_';
export const READ = 'READ_';
export const CHECK = 'CHECK_';
export const TRACK = 'TRACK_';
export const EDIT = 'EDIT_';
export const DUPLICATE = 'DUPLICATE_';
export const LOADED = 'LOADED_';
export const PROGRESS = 'PROGRESS_';
export const COMPLETE = 'COMPLETE_';
export const ERROR = 'ERROR_';
export const FAILED = 'FAILED_';
export const PROCESS = 'PROCESS_';
export const ALIGN = 'ALIGN_';
export const ORDER = 'ORDER_';
export const DRAG = 'DRAG';
export const COLOR = 'COLOR_';
export const STATUS = 'STATUS_';
export const OBJECTS = 'OBJECTS_';
export const HISTORY = 'HISTORY_';
export const REQUEST = 'REQUEST_';
export const TIMEOUTED = 'TIMEOUTED_';
export const HIDDENFEATURE = 'HIDDENFEATURE_';
export const JOB = 'JOB_';
export const TEXTURE = 'TEXTURE_';
export const STRUCT = 'STRUCT_';
export const UUID = 'UUID_';
export const HOVER = 'HOVER_';
export const NEW = 'NEW_';
export const ANNOTATION = 'ANNOTATION_';
export const ANNOTATIONS = 'ANNOTATIONS_';
export const ATTACHMENTS = 'ATTACHMENTS_';
export const TUTORIAL = 'TUTORIAL_';
export const EVENT = 'EVENT_';
export const CONTENT = 'CONTENT_';
export const LICENSE = 'LICENSE_';
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
export const DATA_FOR = 'DATA_FOR_';
export const WS_ = 'WS_';
export const APP = 'APP_';
export const USER = 'USER_';
export const AVAILABLE = 'AVAILABLE_';
export const INSTALLPROMPT = 'INSTALLPROMPT_';
export const INSTALLED = 'INSTALLED_';
export const CLOSE = 'CLOSE_';
export const OPEN = 'OPEN_';
export const BAR = 'BAR_';
export const TOGGLE = 'TOGGLE_';
export const STEP = 'STEP_';
export const TAB = 'TAB_';
export const EMPTY = 'ENPTY_';
export const CONTINUE = 'CONTINUE_';
export const RENAME = 'RENAME_';

export const PROJECTS = 'PROJECTS_';
export const PROJECT = 'PROJECT_';
export const PRESETS = 'PRESETS_';
export const PRESET = 'PRESET_';
export const NOTIFICATIONS = 'NOTIFICATIONS_';
export const NOTIFICATION = 'NOTIFICATION_';
export const BASE = 'BASE_';
export const CHUNK = 'CHUNK_';
export const ACTION = 'ACTION_';
export const ALGORITHMS = 'ALGORITHMS_';
export const FEED = 'FEED';
export const LINK = 'LINK_';
export const BLOCK = 'BLOCK_';
export const META = 'META_';
export const DATA = 'DATA_';
export const ATTACHMENT = 'ATTACHMENT_';
export const PACK = 'PACK_';
export const COUNTS = 'COUNTS_';
export const RECONSTRUCTION = '_RECONSTRUCTION';
export const PRICE = '_PRICE';
export const TRIAL = '_TRIAL';
export const BUYPLAN = '_BUYPLAN';
export const EXTRA = '_EXTRA';
export const DEMO = '_DEMO';
export const ROUTE = 'ROUTE';
export const MEASUREMENT = 'MEASUREMENT_';
export const DISTANCE = 'DISTANCE_';

export const SHARE = 'SHARE_';
export const UPLOAD = 'UPLOAD_';
export const SAVE = 'SAVE_';
export const FOLDER = 'FOLDER_';

export const ACCOUNT = 'ACCOUNT_';
export const LOGOUT = 'LOGOUT_';

export const EDITOR = 'EDITOR_';
export const UI = 'UI_';
export const MODE = 'MODE_';
export const FLIP = 'FLIP_';
export const PANELS = 'PANELS_';
export const SCENE = 'SCENE_';
export const VIEW = 'VIEW_';
export const AS = 'AS_';

export const MAKE_PROJECT_OWN = 'MAKE_PROJECT_OWN';
export const RESET_SUPPORT_PROJECT = 'RESET_SUPPORT_PROJECT';
export const UPDATE_EMBEDDED_SHARING_IN_PROJECT = 'UPDATE_EMBEDDED_SHARING_IN_PROJECT';
export const DELETE_EMBEDDED_SHARING_IN_PROJECT = 'DELETE_EMBEDDED_SHARING_IN_PROJECT';
export const UPDATE_EMBEDDED_SHARING_ROLE = 'UPDATE_EMBEDDED_SHARING_ROLE';
export const SET_ACTIVE_PHOTO_SET = 'SET_ACTIVE_PHOTO_SET';
export const FLUSH_PHOTO_TEXTURING_STATE = 'FLUSH_PHOTO_TEXTURING_STATE';
export const SET_PHOTO_VIEW_EVENT_RECT = 'SET_PHOTO_VIEW_EVENT_RECT';
export const DELETE_PHOTOS = 'DELETE_PHOTOS';
export const TOGGLE_PHOTOS_SORT_BY_NAME = 'TOGGLE_PHOTOS_SORT_BY_NAME';
export const TOGGLE_PHOTOS_SORT_BY_REG_ERROR = 'TOGGLE_PHOTOS_SORT_BY_REG_ERROR';
export const SET_OPEN_PHOTO_SET_LIST = 'SET_OPEN_PHOTO_SET_LIST';
export const SET_PHOTO_LOADING_PROGRESS = 'SET_PHOTO_LOADING_PROGRESS';
export const RESET_PHOTO_LOADING_PROGRESS = 'RESET_PHOTO_LOADING_PROGRESS';

export const UPDATE_WS_PROJECT_CONTENT = 'UPDATE_WS_PROJECT_CONTENT';
export const SET_WS_PROJECT_CONTENT = 'SET_WS_PROJECT_CONTENT';
export const CLEAR_WS_STATE = 'CLEAR_WS_STATE';
export const SET_WS_UPDATE = 'SET_UPDATE_WS_';
export const APPLY_INITIAL_WS_SCENE_SETTINGS = 'APPLY_INITIAL_WS_SCENE_SETTINGS';
export const ADD_WS_OBJECTS_STUBS = 'ADD_WS_STUB_OBJECT';
export const DELETE_WS_OBJECTS_STUBS = 'DELETE_OBJECTS_STUBS';
export const HIDE_WS_OBJECTS = 'HIDE_WS_OBJECTS';
export const RESTORE_WS_OBJECTS_VISIBILITY = 'RESTORE_WS_OBJECTS_VISIBILITY';
export const SAVE_HIDDEN_WS_OBJECTS_IDS = 'SAVE_HIDDEN_WS_OBJECTS_IDS';
export const DELETE_SAVED_HIDDEN_WS_OBJECTS_IDS = 'DELETE_SAVED_HIDDEN_WS_OBJECTS_IDS';
export const HIDE_VISIBLE_MEASURES = 'HIDE_VISIBLE_MEASURES';
export const RESTORE_MEASURES_VISIBILITY = 'RESTORE_MEASURES_VISIBILITY';
export const SAVE_HIDDEN_MEASURES = 'SAVE_HIDDEN_MEASURES';
export const DELETE_SAVED_HIDDEN_MEASURES = 'DELETE_SAVED_HIDDEN_MEASURES';

export const SET_WORKSPACE_WIDTH = 'SET_WORKSPACE_WIDTH';
export const TOGGLE_WORKSPACE_VISIBILITY = 'TOGGLE_WORKSPACE_VISIBILITY';
export const SET_INITIAL_VIEWPORT = 'UPDATE_VIEWPORT';
export const SET_VIEWPORT = 'SET_VIEWPORT';
export const SET_PHOTO_FIT_AREA = 'SET_PHOTO_FIT_AREA';
export const DOWNLOAD_PHOTO_SETS = 'DOWNLOAD_PHOTO_SETS';
export const DOWNLOAD_PHOTOS = 'DOWNLOAD_PHOTOS';

export const CHANGE_NAVIGATION_MODE = 'CHANGE_NAVIGATION_MODE';
export const CHANGE_SHORTCUT_ENABLEMENT = 'CHANGE_SHORTCUT_ENABLEMENT';

export const SET_ACCOUNT = 'SET_ACCOUNT';

export const SET_HISTORY_JUMP_TARGET = 'SET_HISTORY_JUMP_TARGET';
export const HISTORY_JUMP_PERFORMED = 'HISTORY_JUMP_PERFORMED';

export const SAVE_PROJECT_INFO_PREVIEW = 'SAVE_PROJECT_INFO_PREVIEW';
export const SAVE_PROJECT_INFO = 'SAVE_PROJECT_INFO';

export const LOAD_DATA_ROUTES = {
  PROJECTS: '/projects',
  FOLDER: '/folder_content',
  ACCOUNT: '/account',
  PRESETS: '/presets',
};

export const OBJECT_TYPE = {
  FOLDER: 'Folder',
  PROJECT: 'Project',
};

export const LOADERS = 'LOADERS';

export const MODAL = 'MODAL';
export const SHAKE_MODAL = 'SHAKE_MODAL';

export const COLOR_PICKER_PALLETTE = [
  '#EB4F36',
  '#B6D300',
  '#29C4F0',
  '#2F80ED',
  '#3CB54F',
  '#8755FF',
  '#8A5B2B',
  '#D142A0',
  '#FC8B34',
  '#EFC000',
];

export const ALIGN_GREY = '#f3f3f3';

export const EMAIL_REGEXP = /[^@\s]+@[^@\s]+/;

export const CHUNK_SIZE = 5 * 1024 * 1024;

export const API_STATUS = {
  initial: 'initial',
  loading: 'loading',
  loaded: 'loaded',
  error: 'error',
} as const;

export const VIEW_CUBE = {
  normalPosition: {
    width: 150,
    height: 150,
    rightOffset: 160,
    topOffset: 205,
  },
  openMenuPosition: {
    width: 150,
    height: 150,
    rightOffset: 365,
    topOffset: 205,
  },
  hiddenPosition: {
    width: 150,
    height: 150,
    rightOffset: -365,
    topOffset: -205,
  },
};

export const PROJECT_STATUS = {
  preparing: 0,
  new: 1,
  uploading: 2,
  uploaded: 3,
  processing: 4,
  processed: 5,
  enqueued_to_destroy: 6,
  failed_to_upload: 8,
  failed_to_convert: 9,
};

export const DEVICE_MIN_WIDTH = 1280;

export const DESTINATION_TYPES = {
  bell: 2,
  bar: 3,
};

export const DEBOUNCE_UPDATE_TIME = 300;

export const LEFT_PANEL_WIDTH = 210;

export const MAX_RESPONSE_TIME = 2000000000;

export const JOB_TYPES = {
  run_algorithms: 1,
  patch_project_structure: 2,
  send_events_to_node: 3,
  convert_project: 4,
  adjust_texture: 5,
  duplicate_entities: 6,
  delete_entities: 7,
  create_group: 8,
  manual_align: 9,
  import: 10,
  skyrecon: 11,
  as_history_import: 12,
};

export const CONVERTER = {
  AS_TO_WS: 'as_to_ws',
  WS_TO_AS: 'ws_to_as',
  LEO_TO_WS: 'leo_to_ws',
};

export const JOB_STATUSES = {
  processed: 5,
  rolled_back: 7,
};

export const ASTUDIO_SCANNER_TYPES = {
  LType: 'LargeL',
  MType: 'Eva',
  SType: 'Small',
  Spider: 'Spider',
  Leo: 'Leo',
  Ray: 'Ray',
  Micro: 'Micro',
};

export const SNAPSHOT_TYPE = {
  project: 1,
  fusions: 2,
  scans: 3,
  cadobjects: 4,
  point_clouds: 5,
};

export const SNAPSHOT_FORMAT = {
  artec_studio: 1,
  scan: 2,
  obj: 3,
  ply: 4,
  stl: 5,
  vrml: 6,
  phobos: 7,
  step: 8,
  iges: 9,
  x_t: 10,
  igs: 11,
  stp: 12,
  ptx: 13,
  xyz: 14,
  btx: 15,
  btxv2: 16,
  btxv3: 17,
  btxv5: 18,
  btxv6: 19,
  usd: 20,
};

export const ANNOTATION_STATUS = {
  new: 'new',
  resolved: 'resolved',
};

export const IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/vnd.microsoft.icon',
  'image/gif',
  'image/bmp',
  'image/webp',
  'image/svg+xml',
  'image/tiff',
];

export const ANNOTATION_RELOAD_TIME = 20000;

// for visited tutorial store
export const TUTORIAL_SETTINGS = {
  tutorialVisitedOnce: false,
  tutorialmanual: false, // dnt use camel case here
};

export const UI_ELEMENTS = {
  HEADER: 45,
  TOOL: 45,
  LEFT_MENU: 210,
  RIGHT_MENU_WITH_ACTIONS: 257,
};

export const TMP_MIGRATE = '_TMP_MIGRATE';

export enum LICENSE_TYPE {
  Lifetime = 1,
  Subscription = 2,
}

export enum ELicenceCodes {
  FREE = 'ac_free',
  STORAGE_200GB = 'ac_200gb',
  STORAGE_200GB_MO = 'ac_200gb_1mo',
  STORAGE_1TB_MO = 'ac_1tb_1mo',
  STORAGE_1TB = 'ac_1tb',
  STORAGE_1TB_5YEARS = 'ac_1tb_5y',
  UNLIMITED = 'ac_qa_unlimited',
}

export enum RESOURCE_TYPES {
  Size = 1,
  Tokens = 2,
}

export const TRIAL_COOKIE = 'the_trial_product_has_been_successfully_assigned';

export const DAYS_TILL_EXPIRED = 30;
export const DAYS_TILL_DELETED = 90;
export const DAYS_TILL_DELETED_ATTENTION = 14;

export const FREE_LIMIT = 5 * 1024 * 1024 * 1024;
export enum MeasureKind {
  Distances,
  Sections,
  Distancemaps,
}

export const THR_COLOR = '#00E74E';

export const WORKSPACE_PLUS_COLUMNS_GAP = 20;
export const WORKSPACE_PLUS_PADDINGS = 15 + 15 + 10 + 15; // paddingsRight + paddingLeft + buttonPaddings
export const WORKSPACE_PLUS_MIN_WIDTH = 50;

export const DISCRETE_COLORS = [
  '#002AFF',
  '#0883FF',
  '#22B0FF',
  '#35DFFF',
  '#41F5FF',
  '#F1EE00',
  '#FEC900',
  '#FCA400',
  '#FA7500',
  '#F91000',
];

export const GRADIENT_COLORS = ['#002BFF', '#00B2FF', '#00F0FF', '#FAFF00', '#FF8A00', '#FF0000'];

export const EMPTY_PROJECT_SIZE = 31;

export const MAX_DESCRIPTION_SIZE = 1000;
